import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core";
import { getPastReferencesList, joinReferenceIds } from "../../Utils/recurrenceReferences";

function BooleanIndicator({ yes, label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <span style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        flexShrink: 0,
        backgroundColor: yes
          ? "var(--mds_brand_appearance_error_weak_background-color, #fcdde0)"
          : "var(--mds_brand_appearance_success_weak_background-color, #d4edda)",
      }}>
        <McIcon
          icon={yes ? "exclamation-circle" : "check"}
          size="10"
          style={{
            color: yes
              ? "var(--mds_brand_appearance_error_default_on-background-color, #370005)"
              : "var(--mds_brand_appearance_success_default_on-background-color, #155724)",
          }}
        />
      </span>
      <span style={{
        fontSize: "14px",
        fontWeight: yes ? 600 : 400,
        color: yes
          ? "var(--mds_brand_appearance_error_default_text-color, #B80012)"
          : "var(--mds_brand_appearance_default_default_text-color, #141414)",
      }}>
        {label}
      </span>
    </div>
  );
}

function FieldCard({ label, children }) {
  return (
    <div className="report-field-item">
      <span className="report-field-label">{label}</span>
      <div style={{ marginTop: "4px" }}>{children}</div>
    </div>
  );
}

function RootCausection({ data, recurrenceData, images }) {
  const isVendorCaused = data?.causedByVendor && data.causedByVendor !== "" && data.causedByVendor !== "No";
  const vendorLabel = isVendorCaused
    ? data.causedByVendor === "Yes" && (data?.vendorOptions || data?.vendorDetails)
      ? `Yes (${data.vendorOptions || data.vendorDetails})`
      : data.causedByVendor
    : "No";

  const isChangeCaused = data?.impactedByChange === true || data?.impactedByChange === "true" || data?.impactedByChange === "Yes";
  const changeLabel = isChangeCaused ? `Yes${data?.causedByChangeNumber ? ` — ${data.causedByChangeNumber}` : ""}` : "No";

  const pastReferences = getPastReferencesList(recurrenceData);
  const recurringIncidentId = joinReferenceIds(pastReferences) || data?.incidentId;
  const recurringProblemId = joinReferenceIds(pastReferences, "problemId") || data?.problemId;
  const isRecurringIssue = (val) => val && val !== "No" && val !== "no" && val !== "false" && val !== false;
  const isRecurring = !!(isRecurringIssue(recurrenceData?.recurringIssue) || isRecurringIssue(data?.recurringIssue));
  const hasSubCategory = !!(data?.rootCauseSubCategory || data?.subCategory);

  return (
    <div>
      {/* Code + Sub Code + SubCategory */}
      <div className="report-field-grid">
        <FieldCard label="Root Cause Code">
          <span className="report-field-value">{data?.rootCauseCode || <em className="report-field-value is-empty">Not set</em>}</span>
        </FieldCard>

        <FieldCard label="Root Cause Sub Code">
          <span className="report-field-value">{data?.rootCauseSubCode || <em className="report-field-value is-empty">Not set</em>}</span>
        </FieldCard>

        {hasSubCategory ? (
          <FieldCard label="Sub Category">
            <span className="report-field-value">{data?.rootCauseSubCategory || data?.subCategory}</span>
          </FieldCard>
        ) : (
          <div />
        )}
      </div>

      {/* Vendor + Change + Recurrence — highlighted red when Yes */}
      <div className="report-field-grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
        <FieldCard label="Caused By Vendor">
          <BooleanIndicator yes={isVendorCaused} label={vendorLabel} />
        </FieldCard>
        <FieldCard label="Caused By Change">
          <BooleanIndicator yes={isChangeCaused} label={changeLabel} />
        </FieldCard>
        <FieldCard label="Recurrence">
          <BooleanIndicator
            yes={isRecurring}
            label={
              isRecurring
                ? [recurringIncidentId, recurringProblemId].filter(Boolean).join(" / ") || "Yes"
                : "No"
            }
          />
        </FieldCard>
      </div>

      {images && images.length > 0 && (
        <div className="report-images">
          {images.map((image, i) => (
            <img key={i} alt={image.name} src={image.preview} />
          ))}
        </div>
      )}
    </div>
  );
}

export default RootCausection;
